import SavingsGuaranteePerk from './SavingsGuaranteePerk';

export default SavingsGuaranteePerk;
